<template>
  <div class="piggery">
    <div class="banner" :style="`background-image:url(${banner.picUrl})`" @click="goBannerUrl" :class="{canClick: banner.connection}">
      <h1 class="font-60">智能养猪流程闭环 <br />实现人猪分离的养殖模式</h1>
    </div>

    <div class="middle-content">
      <div class="core-item core-1">
        <div class="item-lt">
          <h2>猪小智APP</h2>
          <p>猪场过程化</p>
          <p>精细化管理的好帮手</p>
          <p>实现猪场数据实时</p>
          <p>高效采集</p>
        </div>
        <div class="gray-bg">
          <img class="pig-code" :src="pigCode" />
          <p>打开浏览器，扫码下载</p>
        </div>
      </div>

      <div class="core-item core-2">
        <div class="item-lt">
          <h2>猪小智监管平台</h2>
          <p>国内首家可实施应用的</p>
          <p>猪场物联网监管平台</p>
          <p>实现全程非接触性</p>
          <p>远程智能监管</p>
        </div>
        <div class="gray-bg">
          <img class="pig-code2" src="../../assets/images/core/piggery_logo.png" />
          <p class="link-into" @click="goScreenUrl">点击进入</p>
        </div>
      </div>

      <div class="group-title">
        <p>智能猪场管理专家，适应不同场景和规模猪场</p>
        <p>增设集团版、政府版、猪场版，服务行业多元化应用需求</p>
      </div>

      <div class="group-item">
        <!-- <router-link :to="{name: 'groupEdition'}"> -->
        <div class="group-l core-3">
          <div class="wrap-mask-4">
            <div class="content">
              <p class="title mb-20">集团版</p>
              <p class="detail">生物安全、饲料消耗、设备管理等重要数据的横向对比、 挖掘，提升集团的运营能力</p>
            </div>
          </div>
        </div>
        <!-- </router-link> -->
        <div class="group-r">
          <div class="gove core-4">
            <div class="wrap-mask">
              <div class="content">
                <p class="title mb-20">政府版</p>
                <p class="detail">多系统融合，管理地区内的生猪养殖：生猪存栏监控系统、 可追溯体系、无害化处理体系等，确保行业的健康发展</p>
              </div>
            </div>
          </div>
          <div class="pig core-5">
            <div class="wrap-mask">
              <div class="content">
                <p class="title mb-20">猪场版</p>
                <p class="detail">打破信息孤岛，降低人工数量，有效监管设备，养殖过程 可控，提高投资回报率</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="group-item core-bg">
      <div class="group-from" id="group">
      <form class="form-con" action="">
          <div class="con">
            <div class="con-item">
            <div class="aside-left">
              <span>姓名<span class="red-c">(必填)</span></span><br>
              <el-input v-model="coopName" placeholder="请输入姓名,不超过20个字" @input="handelCoopName"></el-input>
              <br />
              <span>所在公司名称<span class="red-c">(必填)</span></span><br>
              <el-input v-model="company" placeholder="请输入所在公司名称,不超过20个字" @input="handelCompany"></el-input>
            </div>

            <div class="aside-main">
              <span>手机号码<span class="red-c">(必填)</span></span><br>
              <el-input v-model="coopPhone" placeholder="请输入手机号码" @change="handelCoopPhone"></el-input>
              <br />
              <span>选择咨询目的<span class="red-c">(必填)</span></span><br>
              <el-select v-model="objective" placeholder="请选择咨询目的" class="pos-select">
                <el-option
                  v-for="item in consultObjective"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>

            <div class="aside-right">
              <span>电子邮件<span class="red-c">(必填)</span></span><br>
              <el-input v-model="mail" placeholder="请输入电子邮件,不超过40个字" @input="handelMail" @change="handelChangeMail"></el-input>
              <br />
              <span>猪场类型</span><br>
              <el-select v-model="factoryType" placeholder="请选择猪场类型" class="pos-select">
                <el-option
                  v-for="item in fieldType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            </div>
            <div class="consult-con">
              <span>咨询内容<span class="red-c">(必填)</span></span><br>
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入咨询内容"
                v-model="problem"
                maxlength="200"
                show-word-limit
                @blur="handelProblem">
              </el-input>
            </div>
            <div class="form-btn" align="center" id="contact">
              <el-button type="primary" @click="submitCoop" :disabled="isDisabled">发送</el-button>
            </div>
          </div>
        </form>
        </div>
    </div>
      <div id="btn"></div>
      <div class="middle-content mt-50">
        <div class="card">
          <div class="card-con">
            <h2>集团总部: 北京</h2>
            <p>联系方式：4008105353</p>
            <p>工作时间：周一至周六 9:00-18:00</p>
            <p>邮箱：kf@nxin.com</p>
            <p>地址：北京市海淀区中关村大厦16层</p>
          </div>
        </div>
        <div class="card">
          <div class="card-con">
            <h2>人工智能总部: 厦门</h2>
            <p>联系方式：01062698801-8785</p>
            <p>工作时间：周一至周五 9:00-18:00</p>
            <p>邮箱：nxsk@nxin.com</p>
            <p>地址：福建省厦门市软件园三期诚毅北大街62号109单元0361号</p>
          </div>
        </div>
        <div class="card">
          <div class="card-con">
            <h2>西北总部: 西安</h2>
            <p>联系方式：17795672235</p>
            <p>工作时间：周一至周六 9:00-18:00</p>
            <p>邮箱： jingyiyan@nxin.com </p>
            <p>地址： 陕西省西安市未央区凤城十二路凯瑞B座1303</p>
          </div>
        </div>
        <div class="card">
          <div class="card-con">
            <h2>西南总部: 成都</h2>
            <p>联系方式：17711017719/ 18181925402 </p>
            <p>工作时间：周一至周日 24小时</p>
            <p>邮箱：heaiguang@nxin.com</p>
            <p>地址：四川成都市温江区城区德通桥路392号（成都市农业职业科技学院内）</p>
          </div>
        </div>
        <div class="card">
          <div class="card-con">
            <h2>电商平台: 浙江</h2>
            <p>联系电话：0579-89115159 </p>
            <p>工作时间：周一至周六 9:00-18:00 </p>
            <p>邮箱：nxsc@nxin.com</p>
            <p>公司地址：浙江省金华市金东区事业联建楼二期（701）室</p>
          </div>
        </div>
        <div class="card mb-30">
          <div class="card-con">
            <h2>国家生猪交易市场: 重庆</h2>
            <p>联系电话：4000600272</p>
            <p>工作时间：周一至周六 08:30-17:30</p>
            <p>邮箱：zhoujing@nxin.com</p>
            <p>地址：重庆市荣昌区板桥工业园区畜牧产品交易市场</p>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { getSession, setSession } from '@/utils/index'
export default {
  name: 'coreCompetence',
  data () {
    return {
      query: this.$route.query,
      coopName: '',
      coopPhone: '',
      company: '',
      mail: '',
      objective: '',
      factoryType: '',
      problem: '',
      fieldType: getSession('fieldType'),
      consultObjective: getSession('consultObjective'),
      banner: {
        picUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
      },
      isDisabled: true,
      pigCode: '',
      screenUrl: ''
    }
  },
  computed: {
    listenChange () {
      const { coopName, coopPhone, company, mail, objective, factoryType, problem } = this
      return { coopName, coopPhone, company, mail, objective, factoryType, problem }
    }
  },
  watch: {
    listenChange (val) {
      if (val.coopName && val.coopPhone && val.company && val.mail && val.objective && val.factoryType && val.problem) {
        this.isDisabled = false
      } else {
        this.isDisabled = true
      }
      console.log('listenChange', val)
    }
  },
  beforeRouteEnter (to, from, next) {
    if (to.name === 'consult') {
      next((vm) => {
        setTimeout(() => {
          vm.goAnchor()
        }, 0)
      })
    } else {
      next()
    }
  },
  mounted () {
    if (!getSession('fieldType')) {
      this.getAllEnum()
    }
    if (!getSession('bannerPic')) {
      this.getBannerPage()
    } else {
      this.banner = getSession('bannerPic').core_compete || {}
    }
    if (this.query.location === 'base') {
      setTimeout(() => {
        this.goAnchor()
      }, 0)
    } else if (this.query.location === 'contact') {
      setTimeout(() => {
        this.goAnchor2()
      }, 0)
    }
    this.getZhuXiaoZhi()
    this.$scroll.reveal('.banner h1', {
      distance: '50px',
      origin: 'left',
      duration: 1000
    })
  },
  methods: {
    getAllEnum () {
      this.API.basic.getAllEnum().then((res) => {
        setSession('fieldType', res.data.fieldType)
        setSession('consultObjective', res.data.consultObjective)
        this.fieldType = getSession('fieldType')
        this.consultObjective = getSession('consultObjective')
      })
    },
    goAnchor () {
      var anchor = this.$el.querySelector('#group')
      document.documentElement.scrollTop = anchor.offsetTop
    },
    goAnchor2 () {
      var anchor = this.$el.querySelector('#btn')
      document.documentElement.scrollTop = anchor.offsetTop
    },
    /**
    * 获取 banner 图片
    */
    async getBannerPage () {
      const params = {
        currentPage: 1,
        pageSize: 100
      }
      const res = await this.API.basic.getBannerPage(params) || []
      console.log(res, 'aaa')
      // eslint-disable-next-line prefer-const
      let arr = {}
      res.data.map(o => {
        this.$set(arr, o.remark, { picUrl: o.pictureUrl, connection: o.connection })
      })
      this.banner = arr.core_compete
      setSession('bannerPic', arr)
    },
    handelCoopName () {
      if (this.coopName.length > 20) {
        this.$message({
          type: 'error',
          message: '字数不超过20个字!'
        })
      }
    },
    handelCompany () {
      if (this.company.length > 20) {
        this.$message({
          type: 'error',
          message: '字数不超过20个字!'
        })
      }
    },
    handelCoopPhone () {
      const valPhone = /^1\d{10}$/ // 手机号码 /^1(3|4|5|7|8)\d{9}$/,
      if (!valPhone.test(this.coopPhone)) {
        this.$message({
          type: 'error',
          message: '手机号码为11位有效数字!'
        })
      }
    },
    handelMail () {
      if (this.mail.length > 40) {
        this.$message({
          type: 'error',
          message: '字数不超过40个字!'
        })
      }
    },
    handelChangeMail () {
      var regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (!regEmail.test(this.mail)) {
        this.$message({
          message: '邮箱格式不正确',
          type: 'error'
        })
      }
    },
    handelProblem () {
      if (this.problem.length > 200) {
        this.$message({
          type: 'error',
          message: '字数不超过200个字!'
        })
      }
    },
    submitCoop () {
      if (!this.coopName || !this.coopPhone || !this.company || !this.mail || !this.objective || !this.problem) {
        this.$message({
          type: 'error',
          message: '请输入必填项!'
        })
      } else {
        this.isDisabled = false
        this.API.recruit.submitCoop({
          coopName: this.coopName,
          coopPhone: this.coopPhone,
          company: this.company,
          mail: this.mail,
          objective: this.objective,
          factoryType: this.factoryType,
          problem: this.problem
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.coopName = ''
          this.coopPhone = ''
          this.company = ''
          this.mail = ''
          this.objective = ''
          this.factoryType = ''
          this.problem = ''
        })
      }
    },
    /** 跳转banner配置连接 */
    goBannerUrl () {
      if (!this.banner.connection) {
        return ''
      }
      window.open(this.banner.connection)
    },
    /* 猪小智监管平台获取 */
    async getZhuXiaoZhi () {
      this.API.basic.getZhuXiaoZhi().then((res) => {
        if (res.data) {
          this.pigCode = res.data.pictureUrl || ''
          this.screenUrl = res.data.connInfoList[0].superviseUrl || ''
        }
      })
    },
    /* 监管平台跳转 */
    goScreenUrl () {
      if (!this.screenUrl) {
        return ''
      }
      window.open(this.screenUrl)
    }
  }
}
</script>
